var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('nav-bar',{attrs:{"title":['', _vm.$t('用户协议'), _vm.$t('隐私政策')][_vm.type],"left-arrow":""}}),(_vm.list)?_c('div',{staticClass:"htmlcontentbox content",domProps:{"innerHTML":_vm._s(_vm.list)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }